import ReportExportButtonComponent from "./ReportExportButtonComponent"

const ReportHeaderComponent = (props) => {

    const {
        title,
        isFilterExpand,
        setIsFilterExpand,
        exportReport
    } = props

    return (
        <>
            <div className="reports-head-main-filter">
                <div className="report-page-title">
                    {title}
                </div>
                {/* 
                    <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                            Compliance Report
                        </Dropdown.Toggle>

                        {false && <Dropdown.Menu>
                            <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                            <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                            <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                        </Dropdown.Menu>}
                    </Dropdown> 
                */}

                {!isFilterExpand && <div className="applied-filter-box mb-4 cursor-pointer"
                    onClick={() => { setIsFilterExpand(true) }}>
                    <svg fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                        width="18px" height="18px" viewBox="0 0 971.986 971.986">
                        <g>
                            <path d="M370.216,459.3c10.2,11.1,15.8,25.6,15.8,40.6v442c0,26.601,32.1,40.101,51.1,21.4l123.3-141.3
                                                c16.5-19.8,25.6-29.601,25.6-49.2V500c0-15,5.7-29.5,15.8-40.601L955.615,75.5c26.5-28.8,6.101-75.5-33.1-75.5h-873
                                                c-39.2,0-59.7,46.6-33.1,75.5L370.216,459.3z"
                            />
                        </g>
                    </svg>
                    Filters</div>}
            </div>
            {/* <ReportExportButtonComponent exportReport={exportReport()} /> */}
        </>
    )
}

export default ReportHeaderComponent